import React from "react";

import './styles.scss';

import {path$} from "../../../../../../../router";
import {isUserAccessed} from "../../../../../../../emitters/account";

import MerchantNavigationItemLink from "./components/MerchantNavigationItemLink";
import MerchantNavigationItemDropdown from "./components/MerchantNavigationItemDropdown";
import MerchantNavigationItemList from "./components/MerchantNavigationItemList";

export default ({link, subLinks = [], subLinksDisplayType, permissions = [], ...props}) => {
  const path = path$.getValue();
  const active = path.startsWith(link);

  const baseClassName = 'merchant-nav-item';

  const navItemClassName = (
    baseClassName
    + (active ? ' active' : '')
  );

  if (!subLinks.length) {
    let disabled = false;

    if (permissions.length) {
      disabled = permissions.some((perm) => !isUserAccessed(perm));
    }

    return (
      <MerchantNavigationItemLink
        className={navItemClassName}
        href={!disabled ? link : ''}
        {...props}
      />
    )
  }

  return subLinksDisplayType === 'dropdown'
    ? (
      <MerchantNavigationItemDropdown
        baseClassName={baseClassName}
        className={navItemClassName}
        subLinks={subLinks}
        {...props}
      />
    ) : (
      <MerchantNavigationItemList
        baseClassName={baseClassName}
        className={navItemClassName}
        subLinks={subLinks}
        active={active}
        {...props}
      />
    );
};
